<template>
  <div>
    <div class="sku-info-header__wrapper">
      <div class="sku-base-info__wrapper">
        <div class="sku-img__wrapper">
          <el-image
            :src="
              formData.defaultImageUrl
                ? $osscdn(formData.defaultImageUrl)
                : '/image/static/img/nopic-square.jpg'
            "
            :preview-src-list="[
              formData.defaultImageUrl
                ? $osscdn(formData.defaultImageUrl)
                : '/image/static/img/nopic-square.jpg',
            ]"
            style="width: 110px;height: 110px;"
          >
            <div slot="error" class="image-slot">
              <img src="/image/static/img/nopic-square.jpg" />
            </div>
          </el-image>
        </div>
        <div style="flex:1;">
          <div class="d-flex bt-1 bb-1 bl-1">
            <LabelValue>
              <template v-slot:label>
                {{ $l('form_label_evg_sku_number') || 'SKU No' }}
              </template>
              <template v-slot>
                <div style="flex: 1;" class="d-flex justify-content-between">
                  <span>{{ formData.evgSkuNo }}</span>

                  <el-tag
                    v-if="'Y' == formData.isCombine"
                    type="warning"
                    size="mini"
                    effect="plain"
                  >
                    {{ $l('table_label_isCombine') || '组合产品' }}
                  </el-tag>
                </div>
              </template>
            </LabelValue>
            <LabelValue style="flex: 0.7 !important;">
              <template v-slot:label>{{
                $l('label_key_UPC') || 'UPC'
              }}</template>
              <template v-slot>{{ formData.v_channelEanNo }}</template>
            </LabelValue>
          </div>
          <div class="d-flex bb-1 bl-1">
            <LabelValue>
              <template v-slot:label>{{
                $l('label_key_product_name') || '产品名称'
              }}</template>
              <template v-slot>
                <div style="padding: 5px 0;">
                  <span>{{ formData.goodsName }}</span>
                  <br />
                  <span>{{ formData.goodsNameEn }}</span>
                </div>
              </template>
            </LabelValue>
          </div>
          <div class="d-flex bb-1 bl-1">
            <LabelValue>
              <template v-slot:label>{{
                $l('label_key_customer') || 'Customer'
              }}</template>
              <template v-slot>{{ formData.custName }}</template>
            </LabelValue>
            <LabelValue>
              <template v-slot:label>{{
                $l('label_key_brand') || 'Brand'
              }}</template>
              <template v-slot>{{ formData.v_brandName }}</template>
            </LabelValue>
          </div>
          <div class="d-flex bb-1 bl-1">
            <LabelValue>
              <template v-slot:label>{{
                $l('label_key_category') || 'Category'
              }}</template>
              <template v-slot>{{ formData.categoryFullName }}</template>
            </LabelValue>
            <LabelValue>
              <template v-slot:label>{{
                $l('label_key_collection') || 'Collection'
              }}</template>
              <template v-slot>{{ formData.collectionName }}</template>
            </LabelValue>
          </div>
        </div>
      </div>
    </div>
    <div class="side-frame-success d-flex ">
      <span>
        {{ $l('title_sales_channel') || '销售渠道' }}：{{
          formData.platformName
        }}</span
      >
      <el-divider direction="vertical"></el-divider>
      <span>
        {{ $l('form_label_region') || '市场' }}：{{ formData.regionName }}</span
      >
      <el-divider direction="vertical"> </el-divider>
      <b-badge
        style="font-size: 12px;padding: 5px 10px;"
        :variant="
          formData.evgSkuPlatformStatus === 'Y'
            ? 'success'
            : formData.evgSkuPlatformStatus === 'S' ||
              formData.evgSkuPlatformStatus === 'B' ||
              formData.evgSkuPlatformStatus === 'W'
            ? 'danger'
            : formData.evgSkuPlatformStatus === 'X'
            ? 'warning'
            : 'primary'
        "
      >
        {{ formData.v_evgSkuPlatformStatus || '-' }}
      </b-badge>
      <span class="ml-2">
        {{ $l('title_modify') || 'Modify' }}：
        {{ formData.modifyByName ? formData.modifyByName : '--' }} at
        {{ formData.modifyDate ? formData.modifyDate : '--' }}</span
      >
    </div>

    <el-form ref="form" size="mini" :rules="rules" :model="formData">
      <div class="mt-2">
        <div class="summary_title">
          {{ $l('title_product_definition') || '产品定义' }}
        </div>
        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item
              :label="$l('form_label_channelItemNo') || '渠道Item号'"
              prop="channelItemNo"
            >
              <el-input
                v-model="formData.channelItemNo"
                :placeholder="
                  $l('form_placeholder_channelItemNo') || '请输入渠道Item号'
                "
                clearable
                show-word-limit
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="$l('form_label_channelSkuNo') || '渠道款号'"
              prop="channelSkuNo"
            >
              <el-input
                v-model="formData.channelSkuNo"
                :placeholder="
                  $l('form_placeholder_channelSkuNo') || '请输入渠道款号'
                "
                maxlength="50"
                show-word-limit
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="$l('form_label_channelEanNo') || '渠道UPC'"
              prop="channelEanNo"
            >
              <el-input
                v-model="formData.channelEanNo"
                :placeholder="
                  $l('form_placeholder_channelEanNo') || '请输入渠道UPC'
                "
                maxlength="50"
                show-word-limit
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="18">
            <el-form-item
              :label="$l('form_label_sales_title') || '渠道售卖标题'"
              prop="salesTitle"
            >
              <el-input
                v-model="formData.salesTitle"
                clearable
                show-word-limit
                maxlength="500"
                :placeholder="
                  $l('form_placeholder_sales_title') || '请输入渠道售卖标题'
                "
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="$l('form_label_channel_brand') || '渠道售卖品牌'"
              prop="brandCode"
            >
              <dict-select
                clearable
                size="mini"
                v-model="formData.brandCode"
                :selectedLabel.sync="formData.brandName"
                :placeholder="
                  $l('form_placeholder_channel_brand') || '请选择渠道售卖品牌'
                "
                filterable
                url="/master/common/dict/brandSelect"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div class="mt-2">
        <div class="summary_title">
          {{ $l('title_shipping_definition') || '出货定义' }}
        </div>
        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item
              :label="$l('form_label_sellableEachQty') || '最小出货入数'"
              prop="sellableEachQty"
            >
              <el-input-number
                v-model="formData.sellableEachQty"
                :min="0"
                clearable
                style="width: 100%;"
                :placeholder="
                  $l('form_placeholder_sellableEachQty') || '请输入最小出货入数'
                "
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="$l('form_label_sellableEachUnit') || '最小出货单位'"
              prop="sellableEachUnit"
            >
              <dict-select
                v-model="formData.sellableEachUnit"
                url="/master/common/dict/biz"
                :body="{ dictType: 'sellableEachUnit' }"
                :placeholder="
                  $l('form_placeholder_sellableEachUnit') ||
                    '请选择最小出货单位'
                "
                size="mini"
                filterable
                clearable
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div class="mt-2">
        <div class="summary_title">
          {{ $l('title_price_definition') || '价格定义' }}
        </div>
        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item
              :label="$l('form_label_sales_price') || '订单结算价格'"
              prop="salesPrice"
            >
              <el-input-number
                controls-position="right"
                style="width: 100%"
                :min="0"
                :step="0.0001"
                :placeholder="
                  $l('form_placeholder_sales_price') || '请输入订单结算价格'
                "
                :precision="4"
                v-model="formData.salesPrice"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="$l('form_label_actual_price') || '实际结算价格'"
              prop="actualPrice"
            >
              <el-input-number
                controls-position="right"
                style="width: 100%"
                :min="0"
                :step="0.0001"
                :placeholder="
                  $l('form_placeholder_actual_price') || '请输入实际结算价格'
                "
                :precision="4"
                v-model="formData.actualPrice"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="$l('form_label_retail_price') || '终端零售价'"
              prop="retailPrice"
            >
              <el-input-number
                controls-position="right"
                style="width: 100%"
                :min="0"
                :step="0.01"
                :placeholder="
                  $l('form_placeholder_retail_price') || '请输入终端零售价'
                "
                :precision="2"
                v-model="formData.retailPrice"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="$l('form_label_salesCurrencyUnit') || '货币单位'"
              prop="salesCurrencyUnit"
            >
              <dict-select
                size="mini"
                clearable
                filterable
                v-model="formData.salesCurrencyUnit"
                :body="currencyUnitParams"
                url="/master/common/dict/biz"
                :placeholder="
                  $l('form_placeholder_currency_unit') || '请选择货币单位'
                "
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div class="mt-2">
        <div class="summary_title">
          {{ $l('title_shipping_warehouse') || '发货仓库' }}
        </div>
        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item
              :label="$l('form_label_ecomWarehouseCode') || '发货仓库'"
              prop="ecomWarehouseCode"
            >
              <dict-select
                v-model="formData.ecomWarehouseCode"
                url="/ecom/warehouse/warehouse/select/all"
                :placeholder="
                  $l('form_placeholder_ecomWarehouseCode') || '请选择发货仓库'
                "
                size="mini"
                filterable
                clearable
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="$l('form_label_whSkuNo') || '仓库SKU号'"
              prop="whSkuNo"
            >
              <el-input
                v-model="formData.whSkuNo"
                show-word-limit
                clearable
                maxlength="50"
                :placeholder="
                  $l('form_placeholder_whSkuNo') || '请输入仓库SKU号'
                "
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div class="mt-2">
        <div class="summary_title">
          {{ $l('title_channel_gtin') || '渠道GTIN' }}
        </div>
        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item
              :label="$l('form_label_eachGtinNo') || '渠道产品GTIN号'"
              prop="eachGtinNo"
            >
              <el-input
                v-model="formData.eachGtinNo"
                clearable
                show-word-limit
                maxlength="50"
                :placeholder="
                  $l('form_placeholder_eachGtinNo') || '请输入渠道产品GTIN号'
                "
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="$l('form_label_innerPackGtinNo') || '渠道内包装GTIN号'"
              prop="innerPackGtinNo"
            >
              <el-input
                v-model="formData.innerPackGtinNo"
                clearable
                show-word-limit
                maxlength="50"
                :placeholder="
                  $l('form_placeholder_innerPackGtinNo') ||
                    '请输入渠道内包装GTIN号'
                "
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="$l('form_label_caseGtinNo') || '渠道箱GTIN号'"
              prop="caseGtinNo"
            >
              <el-input
                v-model="formData.caseGtinNo"
                clearable
                show-word-limit
                maxlength="50"
                :placeholder="
                  $l('form_placeholder_caseGtinNo') || '请输入渠道箱GTIN号'
                "
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import LabelValue from './label-value.vue'
export default {
  mixins: [EditLoading],
  components: { LabelValue },
  props: {
    platformCode: { type: String, default: '' },
    evgSkuPlatformCode: { type: String, default: '' },
  },
  data() {
    return {
      formData: {},
      backDialogVisible: false,
      chooseEvgSkuVisible: false,
      skuTableData: [],
      currencyUnitParams: { dictType: 'currencyUnit' },
      rules: {
        channelItemNo: [
          {
            required: true,
            trigger: 'blur',
            message:
              this.$l('rules_detail_channelItemNo') || '请输入渠道Item号',
          },
        ],
        channelSkuNo: [
          {
            required: true,
            trigger: 'blur',
            message: this.$l('rules_detail_channelSkuNo') || '请输入渠道款号',
          },
        ],
        channelEanNo: [
          {
            required: true,
            trigger: 'blur',
            message: this.$l('rules_detail_channelEanNo') || '请输入渠道条码号',
          },
        ],
        salesTitle: [
          {
            required: true,
            trigger: 'blur',
            message: this.$l('rules_detail_salesTitle') || '请输入渠道售卖标题',
          },
        ],
        salesPrice: [
          {
            required: true,
            trigger: 'blur',
            message: this.$l('rules_detail_salesPrice') || '请输入售卖价格',
          },
          {
            type: 'number',
            min: 0.01,
            trigger: 'blur',
            message:
              this.$l('rules_detail_correct_salesPrice') ||
              '请输入正确的售卖价格',
          },
        ],
        actualPrice: [
          {
            required: true,
            trigger: 'blur',
            message: this.$l('rules_detail_actualPrice') || '请输入实际结算价格',
          },
          {
            type: 'number',
            min: 0.01,
            trigger: 'blur',
            message:
              this.$l('rules_detail_correct_actualPrice') ||
              '请输入正确的实际结算价格',
          },
        ],
        retailPrice: [
          {
            required: true,
            trigger: 'blur',
            message:
              this.$l('rules_detail_retailPrice') || '请输入终端零售价格',
          },
          {
            type: 'number',
            min: 0.01,
            trigger: 'blur',
            message:
              this.$l('rules_detail_correct_retailPrice') ||
              '请输入正确的终端零售价格',
          },
        ],
        salesCurrencyUnit: [
          {
            required: true,
            trigger: 'change',
            message:
              this.$l('rules_detail_salesCurrencyUnit') || '请选择货币单位',
          },
        ],
        brandCode: [
          {
            required: true,
            trigger: 'change',
            message: this.$l('rules_detail_brandCode') || '请选择品牌',
          },
        ],
        sellableEachUnit: [
          {
            required: true,
            trigger: 'change',
            message:
              this.$l('rules_detail_sellableEachUnit') || '请选择最小出货单位',
          },
        ],
        sellableEachQty: [
          {
            required: true,
            trigger: 'change',
            message:
              this.$l('rules_detail_sellableEachQty') || '请输入最小出货入数',
          },
        ],
      },
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      if (!this.platformCode || !this.evgSkuPlatformCode) return
      this.$api
        .ecomEvgSkuPlatformListingDetailApi({
          platformCode: this.platformCode,
          evgSkuPlatformCode: this.evgSkuPlatformCode,
        })
        .then((res) => {
          this.formData = res?.body || {}
          this.formData.v_channelEanNo = this.formData.channelEanNo
          this.formData.v_brandName = this.formData.brandName
        })
    },
    async validate() {
      const formResult = await validate.formValidate([this.$refs.form])
      return formResult
    },
    async save() {
      if (!(await this.validate())) return (this.backDialogVisible = false)

      const params = { ...this.formData }
      this.loadingOpen()
      const res = await this.$api
        .ecomEvgSkuPlatformListingSaveApi(params)
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status } = res || {}
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      this.close()
      this.$emit('reload')
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
.sku-base-info__wrapper {
  display: flex;
  margin-bottom: 20px;
  .sku-img__wrapper {
    border: 1px solid #efefef;
    border-right: none;
    width: 130px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.side-frame-success {
  padding: 1px 7px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #6c6c6c;
}
.bt-1 {
  border-top: 1px solid #efefef;
}
.bb-1 {
  border-bottom: 1px solid #efefef;
}
.bl-1 {
  border-left: 1px solid #efefef;
}
.summary_title {
  font-size: 14px;
  color: #101010;
  font-weight: 600;
  margin-bottom: 12px;
}
</style>
